import React from 'react';
import { Card } from 'antd';
import Grid from '../Grid';
import Paragraph from './paragraph';
import times from 'lodash/times';
const Cards = ({ items, span, size, content, gutter }) => (React.createElement(Grid.Row, { gutter: gutter }, times(items).map(index => (React.createElement(Grid.Col, { key: index, span: span },
    React.createElement(Card, { size: size }, content ? content() : React.createElement(Paragraph, { active: true, titleWidth: '50%', rows: 4, rowWidth: ['100%', '25%', '50%'] })))))));
export default Cards;
